import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "header-tab" }
const _hoisted_3 = { class: "row flex-left" }
const _hoisted_4 = ["onClick"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: $event => (_ctx.setActiveTab(tab)),
            class: _normalizeClass({ 'active': (tab?.name === _ctx.active || tab === _ctx.active) })
          }, _toDisplayString(_ctx.$i18n.locale === 'en' ? tab?.en : tab?.km), 11, _hoisted_4))
        }), 256))
      ])
    ])
  ]))
}